// extracted by mini-css-extract-plugin
export default {"web":"WebThemeDesignerPage_web__pVApH"};